var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainTaskComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#731172"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0568 12.8625L5.1318 9.81174C4.95607 9.62846 4.95607 9.33128 5.1318 9.14798L5.76818 8.48422C5.94391 8.30091 6.22885 8.30091 6.40458 8.48422L8.375 10.5393L12.5954 6.13746C12.7712 5.95418 13.0561 5.95418 13.2318 6.13746L13.8682 6.80123C14.0439 6.98451 14.0439 7.28169 13.8682 7.46499L8.6932 12.8625C8.51745 13.0458 8.23253 13.0458 8.0568 12.8625Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainTaskComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/main-task-complete.68eda6441404f11cdbcf39a3af615518.svg";